import { IPalette } from '@fluentui/react';

export const getStyles = (palette: IPalette) => {
  return {
    valueHeader: {
      fontSize: 10,
      color: palette.themePrimary,
    },
    keyHeader: {
      fontSize: 10,
    },
    paddingHor: {
      paddingHorizontal: 10,
    },
  };
};
